module.exports = __webpack_public_path__ + "static/media/DescriptionPackageIcon.4ba4032f.svg";